@use "@fukuri-admins/ui/layout" as *;

.content {
  height: inherit;
  padding: spacing("24");
}
